import { render, staticRenderFns } from "./general.vue?vue&type=template&id=9f084608&"
import script from "./general.vue?vue&type=script&lang=ts&"
export * from "./general.vue?vue&type=script&lang=ts&"
import style0 from "./general.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports